(function ($, I18n, moment) {
  var FORMAT = 'YYYY-MM-DD HH:mm:ss';
  var DAY_START = {
    hour: 0,
    minute: 0,
    second: 0
  };
  var DAY_END = {
    hour: 23,
    minute: 59,
    second: 59
  };
  var util = null;
  var col2 = 'col-sm-2 col-md-2 col-lg-2 col-xl-2';
  var col4 = 'col-sm-4 col-md-4 col-lg-4 col-xl-4';

  function Translate() {
    var _this2 = this;

    var keys = ['select_month', 'select_week', 'select_range', 'this_month', 'last_month', 'cw', 'this_week', 'last_week', 'week_start', 'monday', 'sunday', 'from', 'to'];
    keys.forEach(function (key) {
      _this2[key] = I18n.t('javascript.' + key);
    });
    this.locale = I18n.locale;
  }

  function Utility() {
    this.week_start_at_sunday = false;
    this.t = new Translate();

    this.setWeekStart = function (weekStart) {
      var SUNDAY = 7;
      this.week_start_at_sunday = Boolean(weekStart);
      moment.updateLocale(this.t.locale, {
        week: {
          dow: this.week_start_at_sunday ? SUNDAY : 1
        }
      });
    };

    this.isWeekStartSunday = function () {
      return this.week_start_at_sunday;
    };

    this.setWeekStart(0);
  }

  Utility.prototype.getThisYear = function () {
    return moment().year();
  };

  Utility.prototype.getYearsList = function () {
    var STARTING_YEAR = 2008;
    var list = [];

    for (var year = STARTING_YEAR; year <= this.getThisYear(); year += 1) {
      list.push({
        text: year,
        value: year
      });
    }

    return list;
  };

  Utility.prototype.getThisMonth = function () {
    return moment().month() + 1;
  };

  Utility.prototype.getMonthsList = function () {
    var MONTHS_COUNT = 12;
    var list = [];

    for (var i = 1; i <= MONTHS_COUNT; i += 1) {
      list.push({
        text: i,
        value: i
      });
    }

    return list;
  };

  Utility.prototype.getThisMonthRange = function () {
    return {
      from: moment().startOf('month'),
      to: moment()
    };
  };

  Utility.prototype.getLastMonthRange = function () {
    return {
      from: moment().subtract(1, 'month').startOf('month'),
      to: moment().subtract(1, 'month').endOf('month')
    };
  };

  Utility.prototype.getThisWeek = function () {
    return moment().isoWeek();
  };

  Utility.prototype.getWeekList = function (cw) {
    var list = [];
    var iterator = this.week_start_at_sunday ? 0 : 1;
    var weekCounter = 0;

    for (var i = iterator; i <= this.getThisWeek() + iterator; i += 1) {
      try {
        var start = moment().weekday(0).week(i).startOf('week').format('DD.MM');
        var end = moment().weekday(0).week(i).endOf('week').format('DD.MM');
        var text = cw + ' ' + weekCounter + ' (' + start + ' - ' + end + ')';
        list.push({
          text: text,
          value: weekCounter
        });
        weekCounter += 1;
      } catch (error) {
        throw new Error('Error generating week list for week:', i, error);
      }
    }

    return list;
  };

  Utility.prototype.getThisWeekRange = function () {
    return {
      from: moment().weekday(0).startOf('week'),
      to: moment()
    };
  };

  Utility.prototype.getLastWeekRange = function () {
    var ONE_WEEK = 6;
    return {
      from: moment().weekday(0).subtract(ONE_WEEK, 'days').startOf('week'),
      to: moment().weekday(0).subtract(ONE_WEEK, 'days').endOf('week')
    };
  };

  function View($container) {
    this.$container = $container;
    this.t = new Translate();

    this.htmlRow = function (text) {
      var label = $('<label/>', {
        "class": 'control-label ' + col2
      }).text(text);
      return $('<div/>', {
        "class": 'form-group'
      }).append(label);
    };

    this.createSelect = function (className, options) {
      var $select = $('<select/>', {
        "class": className
      });

      for (var i = 0; i < options.length; i += 1) {
        var $option = $('<option/>').text(options[i].text).val(options[i].value);
        $select.append($option);
      }

      return $select;
    };

    this.createButton = function (text, onClick) {
      var $button = $('<button/>', {
        "class": 'btn btn-primary btn-block'
      }).text(text);
      $button.on('click', function (e) {
        e.preventDefault();
        onClick();
      });
      return $button;
    };

    this.createInputGroup = function (text, name) {
      var $inputGoroup = $('<div/>', {
        "class": 'input-group'
      });
      var $inputAddon = $('<div/>', {
        "class": 'input-group-addon',
        text: text
      });
      var $input = $('<input/>', {
        "class": 'form-control',
        name: name,
        id: name
      });
      return $inputGoroup.append($inputAddon, $input);
    };

    this.$wrapper = $('<div/>', {
      "class": 'search daterange-picker'
    });
    this.$monthRow = this.htmlRow(this.t.select_month);
    this.$weekRow = this.htmlRow(this.t.select_week);
    this.$pickerRow = this.htmlRow(this.t.select_range);
    this.$wrapper.append(this.$monthRow, this.$weekRow, this.$pickerRow).appendTo(this.$container);
  }

  View.prototype.createSelectYear = function (onChange) {
    var list = util.getYearsList();
    this.$selectYear = this.createSelect('year form-control', list);
    this.$selectYear.on('change', onChange);
    this.$selectYear.val(util.getThisYear());
    this.$monthRow.append($('<div/>', {
      "class": col2
    }).append(this.$selectYear));
  };

  View.prototype.createSelectMonth = function (onChange) {
    var list = util.getMonthsList();
    this.$selectMonth = this.createSelect('month form-control', list);
    this.$selectMonth.on('change', onChange);
    this.$selectMonth.val(util.getThisMonth());
    this.$monthRow.append($('<div/>', {
      "class": col2
    }).append(this.$selectMonth));
  };

  View.prototype.createThisMonthButton = function (onClick) {
    this.$thisMonth = this.createButton(this.t.this_month, onClick);
    this.$monthRow.append($('<div/>', {
      "class": col2
    }).append(this.$thisMonth));
  };

  View.prototype.createLastMonthButton = function (onClick) {
    this.$lastMonth = this.createButton(this.t.last_month, onClick);
    this.$monthRow.append($('<div/>', {
      "class": col2
    }).append(this.$lastMonth));
  };

  View.prototype.updateMonthRow = function (daterange) {
    this.$selectMonth.val(daterange.from.month() + 1);
    this.$selectYear.val(daterange.from.year());
  };

  View.prototype.createSelectWeek = function (onChange) {
    var list = util.getWeekList(this.t.cw);
    this.$selectWeek = this.createSelect('week form-control', list);
    this.$selectWeek.on('change', onChange);
    this.$selectWeek.val(util.getThisWeek());
    this.$weekRow.append($('<div/>', {
      "class": col4
    }).append(this.$selectWeek));
  };

  View.prototype.createThisWeekButton = function (onClick) {
    this.$thisWeek = this.createButton(this.t.this_week, onClick);
    this.$weekRow.append($('<div/>', {
      "class": col2
    }).append(this.$thisWeek));
  };

  View.prototype.createLastWeekButton = function (onClick) {
    this.$lastWeek = this.createButton(this.t.last_week, onClick);
    this.$weekRow.append($('<div/>', {
      "class": col2
    }).append(this.$lastWeek));
  };

  View.prototype.updateWeekRow = function (daterange) {
    this.$selectWeek.val(daterange.to.isoWeek());
  };

  View.prototype.createWeekStartDayRadioButton = function (onChange) {
    var columns = 'col-sm-12 col-sm-offset-2 col-md-12 col-md-offset-2';
    var $radioGroup = $('<div/>', {
      "class": columns + ' col-lg-4 col-xl-4'
    });
    var inputs = [this.t.monday, this.t.sunday];
    $radioGroup.append($('<label/>', {
      "class": 'radio-inline'
    }).text(this.t.week_start));

    for (var i = 0; i < inputs.length; i += 1) {
      var $label = $('<label/>', {
        "class": 'radio-inline'
      });
      var $radioInput = $('<input/>', {
        name: 'week_start',
        value: i,
        type: 'radio'
      }).prop('checked', i === 0);
      $radioInput.on('change', onChange);
      $label.append($radioInput).append(' ' + inputs[i]);
      $radioGroup.append($label);
    }

    this.$weekRow.append($radioGroup);
  };

  View.prototype.updateSelectWeekOptions = function (weekStart) {
    util.setWeekStart(parseInt(weekStart, 10));
    var list = util.getWeekList(this.t.cw);
    var html = this.createSelect('week form-control', list).html();
    this.$selectWeek.html(html).val(util.getThisWeek());
  };

  View.prototype.createDateTimePicker = function (onChange, onHide) {
    this.$fromGroup = this.createInputGroup(this.t.from, 'from');
    this.$toGroup = this.createInputGroup(this.t.to, 'to');
    this.$fromInput = this.$fromGroup.find('input');
    this.$toInput = this.$toGroup.find('input');
    var columns = 'col-sm-4 col-md-4 col-lg-4 col-xl-2';
    this.$pickerRow.append($('<div/>', {
      "class": columns
    }).append(this.$fromGroup)).append($('<div/>', {
      "class": columns
    }).append(this.$toGroup));
    moment.updateLocale(this.t.locale, {
      week: {
        dow: 1
      }
    });
    var defaultOptions = {
      format: FORMAT,
      sideBySide: true,
      maxDate: moment(DAY_END),
      locale: moment.locale(this.t.locale)
    };
    this.$pickerRow.find('input').datetimepicker(defaultOptions);
    this.fromPicker = this.$fromInput.data('DateTimePicker');
    this.toPicker = this.$toInput.data('DateTimePicker');
    this.fromPicker.defaultDate(moment(DAY_START).subtract(1, 'M')).viewDate(moment(DAY_START).subtract(1, 'M'));
    this.toPicker.defaultDate(moment(DAY_END)).viewDate(moment(DAY_END));
    this.$fromInput.on('dp.change', onChange).on('dp.hide', onHide);
    this.$toInput.on('dp.change', onChange).on('dp.hide', onHide);
  };

  function DateRange() {
    this.to = moment(DAY_END);
    this.from = moment(DAY_START).subtract(1, 'month');
  }

  DateRange.prototype.set = function (object) {
    this.from = object.from;
    this.to = object.to;
  };

  DateRange.prototype.updateByYear = function (year) {
    this.from.year(year);
    this.to.year(year);
  };

  DateRange.prototype.updateByMonth = function (month) {
    this.from.month(month - 1);
    this.to.month(month - 1);
  };

  DateRange.prototype.updateByWeek = function (week) {
    var increment = util.isWeekStartSunday() ? 0 : 1;
    this.from = moment().weekday(0).week(week + increment).startOf('week');
    this.to = moment().weekday(0).week(week + increment).endOf('week');

    if (week === util.getThisWeek()) {
      this.to = moment();
    }
  };

  function RangePicker($container, settings) {
    this.view = new View($container);
    this.daterange = new DateRange();
    this.settings = settings;
  }

  RangePicker.prototype.applyMonthPicker = function () {
    var _this = this;

    _this.view.createSelectYear(function () {
      _this.daterange.updateByYear(this.value);

      _this.updateRow(_this.view.$monthRow);
    });

    _this.view.createSelectMonth(function () {
      _this.daterange.updateByMonth(this.value);

      _this.updateRow(_this.view.$monthRow);
    });

    _this.view.createThisMonthButton(function () {
      _this.daterange.set(util.getThisMonthRange());

      _this.view.updateMonthRow(_this.daterange);

      _this.updateRow(_this.view.$monthRow);
    });

    _this.view.createLastMonthButton(function () {
      _this.daterange.set(util.getLastMonthRange());

      _this.view.updateMonthRow(_this.daterange);

      _this.updateRow(_this.view.$monthRow);
    });
  };

  RangePicker.prototype.applyWeekPicker = function () {
    var _this = this;

    _this.view.createSelectWeek(function () {
      _this.daterange.updateByWeek(parseInt(this.value, 10));

      _this.updateRow(_this.view.$weekRow);
    });

    _this.view.createThisWeekButton(function () {
      _this.daterange.set(util.getThisWeekRange());

      _this.view.updateWeekRow(_this.daterange);

      _this.updateRow(_this.view.$weekRow);
    });

    _this.view.createLastWeekButton(function () {
      _this.daterange.set(util.getLastWeekRange());

      _this.view.updateWeekRow(_this.daterange);

      _this.updateRow(_this.view.$weekRow);
    });

    _this.view.createWeekStartDayRadioButton(function () {
      _this.view.updateSelectWeekOptions(this.value);

      _this.daterange.set(util.getThisWeekRange());

      _this.updateRow(_this.view.$weekRow);
    });
  };

  RangePicker.prototype.applyDateRangePicker = function () {
    var _this = this;

    _this.view.createDateTimePicker(function () {
      _this.updateAltFields();
    }, function () {
      _this.highlight(_this.view.$pickerRow);
    });
  };

  RangePicker.prototype.highlight = function ($row) {
    this.view.$monthRow.removeClass('highlight');
    this.view.$weekRow.removeClass('highlight');
    this.view.$pickerRow.removeClass('highlight');
    $row.addClass('highlight');
  };

  RangePicker.prototype.updateRow = function (row) {
    this.highlight(row);
    this.update();
  };

  RangePicker.prototype.update = function () {
    if (this.view.$fromGroup) {
      this.view.fromPicker.date(this.daterange.from).viewDate(this.daterange.from);
      this.view.toPicker.date(this.daterange.to).viewDate(this.daterange.from);
    }

    this.updateAltFields();
  };

  RangePicker.prototype.setAltFields = function (altFields) {
    this.altFields = altFields ? altFields : false;
  };

  RangePicker.prototype.updateAltFields = function () {
    if (!this.altFields) {
      return;
    }

    var fromDate = this.view.fromPicker.date();
    var toDate = this.view.toPicker.date();

    if (!fromDate || !toDate) {
      return;
    }

    var $fromAltField = $('#' + this.altFields.from);
    var $toAltField = $('#' + this.altFields.to);

    if ($fromAltField.length && $toAltField.length) {
      $fromAltField.val(fromDate.format(FORMAT));
      $toAltField.val(toDate.format(FORMAT));
    } else {
      throw new Error('Alt fields elements not found in the DOM.');
    }
  };

  $.fn.datetimerangepicker = function (options) {
    try {
      var _this = this;

      var defaults = {
        altFields: false
      };
      var settings = $.extend(defaults, options);
      var rangepicker = new RangePicker(_this.first(), settings);
      util = new Utility();
      rangepicker.applyMonthPicker();
      rangepicker.applyWeekPicker();
      rangepicker.applyDateRangePicker();
      rangepicker.setAltFields(settings.altFields);
      return _this;
    } catch (error) {
      throw new Error('Error initializing date time range picker: ' + error.message);
    }
  };

  $.fn.daterange_picker = $.fn.datetimerangepicker;
})(jQuery, I18n, moment);